// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphResponsiveImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphResponsiveImage.tsx");
  import.meta.hot.lastModified = "1732036225886.714";
}
// REMIX HMR END

import { Image } from "@unpic/react";
import clsx from "clsx";
import { Fragment } from "react";
import Heading from "../Heading";
const BREAKPOINTS = {
  mobile: 640,
  tablet: 768,
  desktop: 1024
};
export default function ResponsiveImages({
  background,
  breakpointChange,
  images,
  subtitle,
  titleOptional
}) {
  const [{
    mediaImage
  }, {
    mediaImage: secondImage
  }] = images;
  const breakpoint = breakpointChange in BREAKPOINTS ? BREAKPOINTS[breakpointChange] : BREAKPOINTS.mobile;
  const hasPreviousContent = titleOptional || subtitle;
  const Wrapper = hasPreviousContent ? "div" : Fragment;
  const textColor = background === "dark" ? "!text-neutral-100" : undefined;
  return <Wrapper className="flex flex-col items-start">
      {titleOptional && <div className={clsx("w-full text-center")}>
          <Heading tag="h2" className={textColor}>
            {titleOptional}
          </Heading>
      </div>}
      {subtitle && <div className={clsx("w-full text-center")}>
          <Heading tag={titleOptional ? "h3" : "h2"} className={textColor}>
            {subtitle}
          </Heading>
        </div>}
      <picture className="w-full">
        <source srcSet={secondImage.url} media={`(min-width: ${breakpoint + 1}px)`} width={secondImage.width} height={secondImage.height} />
        <source srcSet={mediaImage.url} media={`(max-width: ${breakpoint}px)`} width={mediaImage.width} height={mediaImage.height} />
        <Image width={mediaImage.width} height={mediaImage.height} layout="constrained" className="w-full" src={mediaImage.url} />
      </picture>
    </Wrapper>;
}
_c = ResponsiveImages;
var _c;
$RefreshReg$(_c, "ResponsiveImages");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;